import { useMemo } from 'react';
import { useProducts } from './useProducts';
import { useLenders } from './useLenders';

export function useUrnResolver() {
  const { data: products } = useProducts();
  const { data: lenders } = useLenders();

  const productMap = useMemo(() => {
    const map = new Map<string, string>();
    if (products) {
      for (const p of products) {
        map.set(p.urn, p.productName || p.upc);
      }
    }
    return map;
  }, [products]);

  const lenderMap = useMemo(() => {
    const map = new Map<string, string>();
    if (lenders) {
      for (const l of lenders) {
        map.set(l.urn, l.displayName || l.name);
      }
    }
    return map;
  }, [lenders]);

  const resolveProductUrn = (urn: string | undefined | null): string => {
    if (!urn) return '-';
    if (typeof urn !== 'string') return String(urn);
    return productMap.get(urn) || urn.split(':').pop() || urn;
  };

  const resolveLenderUrn = (urn: string | undefined | null): string => {
    if (!urn) return '-';
    if (typeof urn !== 'string') return String(urn);
    return lenderMap.get(urn) || urn.split(':').pop() || urn;
  };

  const resolveUserUrn = (urn: string | undefined | null): string => {
    if (!urn) return '-';
    if (typeof urn !== 'string') return String(urn);
    return urn.split(':').pop() || urn;
  };

  return { resolveProductUrn, resolveLenderUrn, resolveUserUrn, productMap, lenderMap };
}
